<template>
	<div class="d-flex flex-column homeMenu-container h-100">

		<div class="pt-2 pb-2 text-center">
			<img
				class="company-logo-desktop"
				v-if="$store.state.authenticated && $store.state.affiliatedUser.establishments[0].es_avatar"
				style="max-width: 200px;width:100%;"
				:src="`${this.$config.server_url}${$store.state.affiliatedUser.establishments[0].es_avatar}`"
				alt=""
			/>
			<img v-else class="company-logo-desktop" src="/images/logo_emotivi.png" alt="" />
		</div>

		<div class="d-flex flex-row header-container rounded" data-scroll="0">
			
			<div class="align-content-center avatar-container"> 
				<img class="rounded-circle img-fluid" src="/images/avatar.png" />
			</div>

			<div class="flex-grow-1 align-content-center justify-align-center ps-2 "> 
				<div class="fw-bold">{{name}}</div>
				<div>
					<button class="btn btn-outline btn-sm p-1" @click="logout">
						<icon class="me-1 small-icon" name="power-off"></icon> Deconnexion
					</button>
				</div>
			</div>
		</div>
		<div class="flex-grow-1 menu"> 
			<MenuItem :data="item" v-for="item in items" :key="item.i" />
		</div>
	</div>
</template>

<script>
//import Avatar from "../Avatar.vue";

const debounce = (fn) => {
    let frame;
    return (...params) => {
        if (frame) {
            cancelAnimationFrame(frame);
        }
        frame = requestAnimationFrame(() => {
            fn(...params);
        });
    };
};

export default {
	name: "LeftMenu",
	props: {},
	created: function () {
		this.displayButton();
	},
	computed: {
		lang() {
			return this.$store.state.lang;
		},
		avatar() {
			return this.$store.state.user.avatar ? this.$store.state.user.avatar : "/assets/avatar.png";
		},
		name() {
			return `${this.$store.state.user.co_invoice_firstname} ${this.$store.state.user.co_invoice_name}`;
		},
		isAdmin() {
			return this.$store.state.isAdminCodeValid;
		}
	},
	data: function () {
		return {
			items: null
		};
	},
	components: {

	},

	mounted() {
		let elt = document.querySelector(".menu");
		elt.addEventListener("scroll", debounce(this.storeScroll));
		console.log("user",  this.$store.state.user, this.$store.state.affiliatedUser)
	},

	unmounted() {
		let elt = document.querySelector(".menu");
		elt.removeEventListener("scroll", debounce(this.storeScroll));
	},

	methods: {

		fetchData() {

			let items = [
				{
					label: "Abonnement",
					route: "privatepayments",
					color: "home",
					icon: "file-invoice-dollar"
				},
				{
					label: "Mon compte",
					route: "privateaccount",
					color: "blueChill",
					icon: "user"
				},
				{
					label: "Kit Emotivi",
					route: "privatebox",
					color: "mediumAquamarine",
					icon: "hdd"
				},
				{
					label: "Mes commandes",
					route: "privateparcel",
					color: "darkTurquoise",
					icon: "home"
				},
				{
					label: "FAQ",
					route: "faq",
					color: "montana",
					icon: "question-circle"
				}
			]

			this.items = items;
		},

		storeScroll() {
			let elt = document.querySelector(".header-container");
			let menuElt = document.querySelector(".menu");
			if(elt) elt.dataset.scroll = menuElt.scrollTop;
		},

		logout() {

			this.$store.commit("set_connexion");
			this.$router.push("/");

		},

		logoutAffiliate() {

			this.$store.commit("set_authentification");
			this.$router.push("/login/affiliate");

		},

		displayButton() {
			this.fetchData();
		}
	},
	watch: {
		lang() {
			this.displayButton();
		},
		isAdmin() {
			this.displayButton();
		}
	}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

.company-logo-desktop {
	max-height: 60px;
}

.small-icon {
	width: 14px;
	height: 14px;
}

.header-container {
	padding: 15px !important;
}

.header-container:not([data-scroll='0']) {
    box-shadow: 0px 5px 10px -10px rgba(0, 0, 0, 0.5);
}

.homeMenu-container {
	width: 100%;
}

.avatar-container {
	position: relative;
	width: 50px;
	height: 50px;
}

.avatar-container img {
	height: 100%;
	width: 100%;
	box-shadow: 0 0 0px 2px #9da1a3;
}

@media (min-width: 992px) {
	.header-container {
		padding: 15px !important;
	}
}

</style>